import { createReducer, on } from '@ngrx/store';
import * as InventoryActions from './inventory.actions';
import { Product } from './inventory.models';

// -----------------------------------------------------------------------------------------------------
// @ States
// -----------------------------------------------------------------------------------------------------

export interface InventoryState {
    inventory: Product[];
    inventoryByLocation: Product[];
    isLoading: boolean;
    error: string | null;
}

// -----------------------------------------------------------------------------------------------------
// @ Initial States
// -----------------------------------------------------------------------------------------------------

export const initialInventoryState: InventoryState = {
    inventory: [],
    inventoryByLocation: [],
    isLoading: false,
    error: null,
};

// -----------------------------------------------------------------------------------------------------
// @ Reducers
// -----------------------------------------------------------------------------------------------------

// Inventory Reducer
export const inventoryReducer = createReducer(
    initialInventoryState,

    // On Load Inventory
    on(InventoryActions.loadInventory, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(InventoryActions.loadInventorySuccess, (state, { data }) => ({
        ...state,
        isLoading: false,
        inventory: data,
    })),
    on(InventoryActions.loadInventoryFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Load Inventory By Location
    on(InventoryActions.loadInventoryByLocation, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(InventoryActions.loadInventoryByLocationSuccess, (state, { data }) => ({
        ...state,
        isLoading: false,
        inventoryByLocation: data,
    })),
    on(InventoryActions.loadInventoryByLocationFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Clear Inventory
    on(InventoryActions.clearInventory, (state) => ({
        ...state,
        isLoading: false,
        inventory: [],
    }))

    // // On Load Single Inventory
    // on(InventoryActions.loadInventory, (state) => ({
    //     ...state,
    //     isLoading: true,
    // })),
    // on(InventoryActions.loadInventorySuccess, (state, { inventory }) => ({
    //     ...state,
    //     isLoading: false,
    //     inventory: inventory,
    // })),
    // on(InventoryActions.loadInventoryFailure, (state, { error }) => ({
    //     ...state,
    //     isLoading: false,
    //     error: error,
    // })),

    // // On Create
    // on(InventoryActions.createInventory, (state) => ({
    //     ...state,
    //     isLoading: true,
    // })),
    // on(InventoryActions.createInventorySuccess, (state, { inventory }) => ({
    //     ...state,
    //     isLoading: false,
    //     inventories: [...state.inventories, inventory],
    // })),
    // on(InventoryActions.createInventoryFailure, (state, { error }) => ({
    //     ...state,
    //     isLoading: false,
    //     error: error,
    // })),

    // // On Update
    // on(InventoryActions.updateInventory, (state) => ({
    //     ...state,
    //     isLoading: true,
    // })),
    // on(InventoryActions.updateInventorySuccess, (state, { inventory }) => ({
    //     ...state,
    //     isLoading: false,
    //     inventories: state.inventories.map((r) =>
    //         r.id === inventory.id ? inventory : r
    //     ),
    // })),
    // on(InventoryActions.updateInventoryFailure, (state, { error }) => ({
    //     ...state,
    //     isLoading: false,
    //     error: error,
    // })),

    // // On Delete
    // on(InventoryActions.deleteInventory, (state) => ({
    //     ...state,
    //     isLoading: true,
    // })),
    // on(InventoryActions.deleteInventorySuccess, (state, { id }) => ({
    //     ...state,
    //     isLoading: false,
    //     inventories: state.inventories.filter((r) => r.id !== id),
    // })),
    // on(InventoryActions.deleteInventoryFailure, (state, { error }) => ({
    //     ...state,
    //     isLoading: false,
    //     error: error,
    // }))
);
